import { client } from "../../infrastructure/graphql/client";
import { 
  GET_VM_DAILY_CPU, 
  GET_VM_DAILY_RAM, 
  GET_VM_DAILY_AVAILABLE_RAM,
  GET_VM_DAILY_METRICS
} from "../../infrastructure/graphql/performanceDetailsQueries";
import { getToken } from "../../infrastructure/storage/tokenStorage";

export class PerformanceDetailsService {
  async getVmDailyCpu(vmId, date) {
    try {
      const token = getToken();
      
      const result = await client.query({
        query: GET_VM_DAILY_CPU,
        variables: { vmId, date },
        fetchPolicy: "network-only",
        context: {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        },
      });

      const response = result.data?.getVmDailyCpu;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM daily CPU error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getVmDailyRam(vmId, date) {
    try {
      const token = getToken();
      
      const result = await client.query({
        query: GET_VM_DAILY_RAM,
        variables: { vmId, date },
        fetchPolicy: "network-only",
        context: {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        },
      });

      const response = result.data?.getVmDailyRam;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM daily RAM error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getVmDailyAvailableRam(vmId, date) {
    try {
      const token = getToken();
      
      const result = await client.query({
        query: GET_VM_DAILY_AVAILABLE_RAM,
        variables: { vmId, date },
        fetchPolicy: "network-only",
        context: {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        },
      });

      const response = result.data?.getVmDailyAvailableRam;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM daily available RAM error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getVmDailyMetrics(vmId, date) {
    try {
      const token = getToken();
      
      const result = await client.query({
        query: GET_VM_DAILY_METRICS,
        variables: { vmId, date },
        fetchPolicy: "network-only",
        context: {
          headers: {
            Authorization: token ? `Bearer ${token}` : "",
          },
        },
      });

      const response = result.data?.getVmDailyMetrics;

      if (!response) {
        return { success: false, message: "No response from server", data: null };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get VM daily metrics error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}